import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import DataTable from 'react-data-table-component';
import {getListOfReceipts} from "../../services/collection-service";
import {workOrderIdEmissions} from "../../pages/Consultation/Consult";

import Swal from "sweetalert2";
import moment from "moment";
import Link from "react-router-dom/es/Link";

export default function ModalReceiptPolicy(props) {

    const [tableReceipts, setTableReceipts] = useState([]);
    const [totalAmount, setTotalAmount] = useState([]);
    const [totalRemaining, setTotalRemaining] = useState([]);

    //When the component starts...
    useEffect(() => {
        //Alert showing we are loading the recipts
        Swal.fire({
            title: 'Cargando Recibos...',
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading(); //Loading animation
                //Request for receipts by workOrderId
                return getListOfReceipts(workOrderIdEmissions).then(data => {
                    setTableReceipts(data); //Filling thew table with the response
                    let totalAmount = 0;
                    let pendingAmount = 0;
                    for (let i in data) { //Setting total out of table
                        totalAmount += data[i].totalPremium;
                        setTotalAmount(totalAmount);
                    }
                    for (let i in data) { //Setting pending amount out of table
                        pendingAmount += data[i].pendingAmount;
                        setTotalRemaining(pendingAmount);
                    }
                }).then(() => Swal.close()).catch(error => {
                    //If something is wrong...
                    Swal.fire({
                        title: 'Ocurrió un error',
                        text: `No se cargaron recibos`,
                        icon: 'error',
                        iconColor: 'var(--skrSecondary)',
                        backdrop: `rgba(71, 10, 104, .75)`,
                        showCancelButton: true,
                        showConfirmButton: false,
                        cancelButtonColor: 'var(--skrSecondary)',
                        cancelButtonText: 'Ok'
                    });
                });
            }
        });
        return () => {
            workOrderIdEmissions = null
        }
    }, []);

    const columnsReceipts = [
        {
            name: 'No. Recibo',
            selector: row => row.receiptNumber,
            sortable: false,
            wrap: true,
            center: true
        },
        {
            name: 'ID de Recibo',
            selector: row => row.receiptId,
            omit: true,
            center: true
        },
        {
            name: 'Serie',
            selector: row => row.serial,
            sortable: false,
            wrap: true,
            center: true
        },
        {
            name: 'Inicio Vigencia',
            selector: row => moment(row.startDate).format('DD/MM/yyyy'),
            sortable: false,
            wrap: true,
            center: true
        },
        {
            name: 'Fin Vigencia',
            selector: row => moment(row.endDate).format('DD/MM/yyyy'),
            sortable: false,
            wrap: true,
            center: true
        },
        {
            name: 'Prima total',
            selector: row => <span>${row.totalPremium.toLocaleString('en', {maximumFractionDigits: 2})}</span>,
            sortable: false,
            wrap: true,
            center: true
        },
        {
            name: 'Monto Pagado',
            selector: row => '$' + row.amountPaid.toLocaleString('en', {maximumFractionDigits: 2}),
            sortable: false,
            wrap: true,
            center: true
        },
        {
            name: 'Monto Pendiente',
            selector: row => '$' + row.pendingAmount.toLocaleString('en', {maximumFractionDigits: 2}),
            sortable: false,
            wrap: true,
            center: true
        },
        {
            name: 'Estado',
            selector: row => row.status,
            conditionalCellStyles: [
                {
                    when: row => row.status === 'Pendiente', //Activo
                    style: {
                        color: '#470A68',
                        fontWeight: 600,
                    },
                },
                {
                    when: row => row.status !== 'Pendiente', //Activo
                    style: {
                        color: '#707070',
                        fontWeight: 600,
                    },
                },
                ],
            sortable: false,
            wrap: true,
            center: true
        },
        {
            name: 'Acciones',
            selector: row =>
                <span>
                    {row.status !== 'Pendiente' || props.userPermissions[3] !==1?
                        <button className="btn btn-skr-secondary btn-sm" disabled={true}>
                            Pagar
                        </button> :
                        <Link to={`/pasarelaPago/${row.receiptId}`}>
                            <button className="btn btn-skr-secondary btn-sm" disabled={false}>
                                Pagar
                            </button>
                        </Link>
                    }
                </span>,
            sortable: false,
            omit: false,
            wrap: true,
            center: true
        }];

    const customStyles = {
        headRow: {
            style: {
                color: 'white !important',
                backgroundColor: 'var(--skrPrimary)',
                padding: '.7rem .3rem !important',
                fontFamily: 'montserratRegular !important',
                fontSize: '.8rem !important',
                borderRadius: '5px'
            },
        },
    };

    return (
        <>
            <Modal show={props.isOpen} onHide={props.toggle} size="xl">
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title>
                        <h5 className="mx-4 montserratMedium" style={{color: 'var(--skrPrimary)'}}>Cobranza</h5>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col">
                                    <DataTable
                                        columns={columnsReceipts}
                                        data={tableReceipts}
                                        pagination={false}
                                        customStyles={customStyles}
                                        dense={true}
                                        responsive={true}
                                        compact={true}
                                        styled
                                        striped/>
                                </div>
                            </div>
                            <div className="row mt-3 float-end">
                                <div className="col-auto mx-2">
                                    <h6 className="text-skrTitle"><b>Total:
                                        ${totalAmount.toLocaleString('en', {maximumFractionDigits: 2})}</b></h6>
                                </div>
                                <div className="col-auto mx-2">
                                    <h6 className="text-skrTitle"><b>Total Pendiente:
                                        ${totalRemaining.toLocaleString('en', {maximumFractionDigits: 2})}</b></h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button className="btn btn-skr-secondary" onClick={props.toggle}>
                        Salir
                    </button>
                </Modal.Footer>

            </Modal>
        </>
    );
}